<template>
  <div class="time-memory">
    <div class="tick" 
    v-for="(t,i) in ticks" 
    :key="i" 
    :style="{ borderColor: getRandomColor() }">{{ t }}</div>
  </div>
</template>
<script>
import { ageBracket, colors } from '../utils'

export default {
  name: 'TimeMemory',
  props: ['date'],
  data () {
    return {}
  },
  computed: {
    ticks () {
      return ageBracket[this.date]
    }
  },
  methods: {
    getRandomColor () {
      const randomColor = Math.floor(Math.random() * colors.length)
      return colors[randomColor]
    }
  }
}
</script>
<style lang="scss" scoped>
.time-memory {
  display: flex;
  flex-wrap: wrap;

  .tick {
    padding: 2px 5px;
    border-radius: 4px;
    margin: 5px;
    font-size: .7rem;
    border-width: 1px;
    border-style: solid;
  }
}  
</style>